import { XMarkIcon } from "@heroicons/react/24/outline"
import React from "react"

import Typography from "../../components/shared/Typography"

import ColorThemeForm from "./sitewide-styles/forms/ColorThemeForm"
import FontsForm from "./sitewide-styles/forms/FontsForm"
import FooterForm from "./sitewide-styles/forms/FooterForm"
import HeaderForm from "./sitewide-styles/forms/HeaderForm"
import LogoForm from "./sitewide-styles/forms/LogoForm"
import ShapeForm from "./sitewide-styles/forms/ShapeForm"
import { useWebsiteBuilderV2 } from "./WebsiteBuilderV2Context"

const EditSitewideStyleScreen = ({ onClose }) => {
  const {
    editingSitewideStyle,
    practice,
    theme,
    handleUpdateTheme,
    setShowEditSitewideStyleScreen,
    setEditingSitewideStyle,
    clearPreview
  } = useWebsiteBuilderV2()

  const handleUpdate = async (updates, options = {}) => {
    try {
      if (options.temporary) {
        await handleUpdateTheme(updates, { temporary: true })
      } else {
        await handleUpdateTheme(updates)
      }
    } catch (error) {
      // Error handling is done in the context
    }
  }

  const handleBack = () => {
    clearPreview()
    setShowEditSitewideStyleScreen(false)
    setEditingSitewideStyle(null)
    onClose()
  }

  if (!editingSitewideStyle) {
    return null
  }

  // Map of style IDs to their components and display names
  const styleConfig = {
    "color-theme": {
      component: ColorThemeForm,
      displayName: "Color Theme"
    },
    fonts: {
      component: FontsForm,
      displayName: "Fonts"
    },
    shape: {
      component: ShapeForm,
      displayName: "Shape"
    },
    logo: {
      component: LogoForm,
      displayName: "Logo"
    },
    header: {
      component: HeaderForm,
      displayName: "Header"
    },
    footer: {
      component: FooterForm,
      displayName: "Footer"
    }
  }

  const config = styleConfig[editingSitewideStyle]
  if (!config) {
    return null
  }

  const StyleComponent = config.component

  return (
    <div className="flex h-full flex-col bg-white">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-gray-200 p-6">
        <Typography variant="h4" className="text-xl font-semibold">
          {config.displayName}
        </Typography>
        <button onClick={handleBack} className="rounded p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600">
          <XMarkIcon className="size-6" />
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        <StyleComponent
          key={theme?.updatedAt || "theme"}
          theme={theme}
          practice={practice}
          onUpdate={handleUpdate}
          onClose={handleBack}
        />
      </div>
    </div>
  )
}

export default EditSitewideStyleScreen
